import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {
  GeneralCardElements,
  LearningSession,
  OrderedCardsList,
  MinimumCourseProps,
  MinimizedCourse,
  User,
  AdminProjectClassProps,
  AdminProjectClass,
  OrdinaryClass,
  TmpList,
  IconAlternatives,
  ColorObject,
  AlertInformation,
  CustomElement,
} from "@/types";
import { IonGrid, IonRow, IonCol, IonAlert } from "@ionic/vue";
import { nextTick, onBeforeUnmount, onMounted, reactive, ref } from "vue";
import { useStore } from "vuex";
import {
  downloadCsv,
  executeLink,
  getBreakpoint,
  getCurrentElement,
  getCustomMessage,
  getIcon,
  getStudyAddressVisualization,
  isSmaller,
  setupError,
} from "@/utils";
import { useRoute } from "vue-router";

type Indexes = {
  group: string;
  index: number;
};
type AvailableModal = "success" | "error";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectClassesList',
  async setup(__props) {

let __temp: any, __restore: any

const is_nothing_selected = () =>
  selected_element_indexes.group == "-1" &&
  selected_element_indexes.index == -1;
const find_element = (
  list: OrderedCardsList<GeneralCardElements>,
  id?: string
): Indexes => {
  const years = Object.keys(list.cards);

  let count = 0;
  let year: string;
  let index: number;

  do {
    year = years[count];
    index = list.cards[year].findIndex((a: GeneralCardElements) => {
      if (id != undefined) {
        return a.id == id;
      } else {
        return a.selected;
      }
    });
    count++;
  } while (index == -1 && count < years.length);

  return {
    group: year,
    index: index,
  };
};
const changeSelection = async () => {
  if (
    selected_element_indexes.group != "-1" &&
    selected_element_indexes.index != -1
  ) {
    selectedChange(
      $route.name == "ordinary_classes" ? school_year_cards : learning_sessions
    );
  }

  const tmp_selected = find_element(
    $route.name == "ordinary_classes" ? school_year_cards : learning_sessions,
    store.state.event.data.id
  );
  if (
    selected_element_indexes.group == tmp_selected.group &&
    selected_element_indexes.index == tmp_selected.index
  ) {
    selected_element_indexes = {
      group: "-1",
      index: -1,
    };
    if ($route.name == "ordinary_classes") {
      ordinary_classes.cards[""] = [];
    } else {
      courses.cards[""] = [];
    }
  } else {
    selected_element_indexes = tmp_selected;
    if ($route.name == "ordinary_classes") {
      ordinary_classes = getClasses();
      selectedChange(school_year_cards);
    } else {
      courses.cards[""] = await getCourses();
      selectedChange(learning_sessions);
    }
  }
};
const selectedChange = (
  list: OrderedCardsList<GeneralCardElements>,
  year = selected_element_indexes.group,
  index = selected_element_indexes.index,
  value = !(
    $route.name == "ordinary_classes" ? school_year_cards : learning_sessions
  ).cards[year][index].selected
) => {
  list.cards[year][index].selected = value;
  trigger.value++;
};
const getCourses = async () =>
  executeLink(
    $route.name == "announcements"
      ? "/v1/students/" +
          user.id +
          "/project_classes?session_id=" +
          learning_sessions.cards[selected_element_indexes.group][
            selected_element_indexes.index
          ].id
      : "/v1/project_classes?session_id=" +
          learning_sessions.cards[selected_element_indexes.group][
            selected_element_indexes.index
          ].id,
    async (response: any) =>
      Promise.all(
        response.data.data.map(
          async (a: MinimumCourseProps | AdminProjectClassProps) => {
            let tmp_project_class: AdminProjectClass;
            let tmp_card: GeneralCardElements;
            if ($route.name == "announcements") {
              tmp_card = new MinimizedCourse(a as MinimumCourseProps).toCard(
                //<!-- TODO (5): finire
                "/announcements/" +
                  (a as MinimumCourseProps).id +
                  "/" +
                  learning_sessions.cards[selected_element_indexes.group][
                    selected_element_indexes.index
                  ].id
              );
            } else {
              tmp_project_class = new AdminProjectClass(
                a as AdminProjectClassProps
              );
              await tmp_project_class.loadParms();
              tmp_card = tmp_project_class.toCard(
                "project_courses/" +
                  (a as AdminProjectClassProps).course_id +
                  "/" +
                  (a as AdminProjectClassProps).learning_session
              );
            }

            return tmp_card;
          }
        )
      )
  );
const getClasses = () => {
  const tmp_classes: OrderedCardsList<GeneralCardElements> = {
    order: [],
    cards: {},
  };

  let study_address_visualization:
    | {
        icon: IconAlternatives;
        background: ColorObject;
      }
    | undefined;
  for (const tmp_class of all_ordinary_classes[
    school_year_cards.cards[selected_element_indexes.group][
      selected_element_indexes.index
    ].id
  ]) {
    if (tmp_classes.cards[tmp_class.address] == undefined) {
      tmp_classes.cards[tmp_class.address] = [];
      study_address_visualization = getStudyAddressVisualization(
        tmp_class.address
      );
      tmp_classes.order.push({
        key: tmp_class.address,
        title: getCustomMessage(
          tmp_class.address,
          study_address_visualization != undefined
            ? {
                text: "" + tmp_class.address,
                icon: study_address_visualization.icon,
                order: true,
              }
            : "",
          study_address_visualization != undefined ? "string_icon" : "string",
          {
            text: {
              name: "white",
              type: "var",
            },
            background: {
              name: "light",
              type: "var",
            },
          },
          {
            item: {
              "ion-no-padding": true,
            },
          }
        ),
      });
    }
    tmp_classes.cards[tmp_class.address].push(
      tmp_class.toCard(
        false,
        false,
        false,
        "/ordinary_classes/" +
          tmp_class.study_year +
          "/" +
          tmp_class.address +
          "/" +
          tmp_class.school_year
      )
    );
  }
  return tmp_classes;
};
const setupModalAndOpen = (window?: AvailableModal, message?: string) => {
  const actual_window: AvailableModal = window ?? store.state.event.event;
  const actual_message: string = message ?? store.state.event.data?.message;

  switch (actual_window) {
    case "success":
      alert_information.title = "";
      alert_information.message =
        actual_message ??
        getCurrentElement(getCurrentElement("successful_operation"));
      alert_information.buttons = [getCurrentElement("ok")];
      alert_open.value = true;
      break;
    case "error":
      setupError(actual_message);
      alert_open.value = true;
      break;
  }
};
const closeModal = (window: AvailableModal) => {
  switch (window) {
    case "success":
    case "error":
      alert_open.value = false;
      break;
  }
};
const exportSubscriptions = async () => {
  executeLink(
    undefined,
    (response) =>
      downloadCsv(response.data, "subscriptions.csv").then(
        (outcome_code) => {
          if (outcome_code == 1) {
            setupModalAndOpen(
              "success",
              getCurrentElement("subscriptions_exported")
            );
          } else if (outcome_code == 0) {
            setupModalAndOpen(
              "error",
              getCurrentElement("no_students") +
                ". " +
                getCurrentElement("no_file_exported")
            );
          } else {
            setupModalAndOpen("error", getCurrentElement("error"));
          }
        },
        () => setupModalAndOpen("error")
      ),
    (error) =>
      setupModalAndOpen(
        "error",
        error.response.status == 404
          ? getCurrentElement("learning_session_error")
          : error.response.status == 400
          ? getCurrentElement("last_session_error")
          : undefined
      ),
    undefined,
    undefined,
    {
      responseType: "blob",
    }
  );
};
const updateBreakpoint = () => {
  breakpoint.value = getBreakpoint(window.innerWidth);
};

const store = useStore();
const user = User.getLoggedUser() as User;
const $route = useRoute();
const alert_information: AlertInformation = store.state.alert_information;

const buttons: CustomElement[] = [
  {
    id: "export",
    type: "string_icon",
    linkType: "request",
    content: {
      text: getCurrentElement("export"),
      icon: getIcon("download"),
      url: "/v1/subscriptions/export",
      method: "get",
      whole_link: true,
    },
    ...store.state.button_css,
  },
];
const promises: Promise<any>[] = [];
const learning_sessions: OrderedCardsList<GeneralCardElements> = reactive({
  order: [],
  cards: {},
});
const courses: OrderedCardsList<GeneralCardElements> = reactive({
  order: [],
  cards: {},
});
const all_ordinary_classes: TmpList<OrdinaryClass[]> = {};
const school_year_cards: OrderedCardsList<GeneralCardElements> = reactive({
  order: [],
  cards: {
    "": [],
  },
});
const school_years =
  $route.name == "announcements"
    ? (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
        "/v1/ordinary_classes?student_id=" + user.id + "&descending=true",
        (response: any) => response.data.data.map((a: any) => a.school_year),
        () => []
      ))),
  __temp = await __temp,
  __restore(),
  __temp
)
    : $route.name == "ordinary_classes"
    ? (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
        "/v1/ordinary_classes?descending=true",
        (response: any) => {
          const tmp_years = new Set();

          let years_size = 0;

          for (const tmp_class of response.data.data) {
            if (tmp_years.add(tmp_class.school_year).size > years_size) {
              years_size++;
              school_year_cards.cards[""].push({
                id: "" + tmp_class.school_year,
                group: "",
                title: getCustomMessage(
                  "title",
                  tmp_class.school_year,
                  "title"
                ),
                selected: false,
                link: {
                  event: "change_selection",
                  data: {
                    id: tmp_class.school_year,
                  },
                },
              });
              all_ordinary_classes[tmp_class.school_year] = [];
            }
            all_ordinary_classes[tmp_class.school_year].push(
              new OrdinaryClass(tmp_class)
            );
          }

          return tmp_years;
        },
        () => []
      ))),
  __temp = await __temp,
  __restore(),
  __temp
)
    : (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
        "/v1/ordinary_classes?descending=true",
        (response: any) => [
          ...new Set(response.data.data.map((a: any) => a.school_year)),
        ],
        () => []
      ))),
  __temp = await __temp,
  __restore(),
  __temp
); //<!-- ? chiedere se c'è api apposta per anni scolastici passati
const trigger = ref(0);
const alert_open = ref(false);
const breakpoint = ref(getBreakpoint(window.innerWidth));

let selected_element_indexes: Indexes = reactive({
  group: "-1",
  index: -1,
});
let ordinary_classes: OrderedCardsList<GeneralCardElements> = reactive({
  order: [],
  cards: {},
});

if (buttons[0].classes == undefined) {
  buttons[0].classes = {};
}
if (buttons[0].classes.button == undefined) {
  buttons[0].classes.button = {};
}
buttons[0].classes.button["ion-padding-start"] = {
  sm: true,
};

if ($route.name != "ordinary_classes") {
  for (const year of school_years) {
    learning_sessions.order.push({
      key: year,
      title: getCustomMessage("title", year, "title"),
    });
    promises.push(
      executeLink(
        "/v1/learning_sessions?school_year=" + year,
        async (response) => {
          learning_sessions.cards[year] = [];
          for (const learning_session of response.data.data) {
            learning_sessions.cards[year].push(
              await new LearningSession(learning_session).toCard(false)
            );
          }
        }
      )
    );
  }
  (
  ([__temp,__restore] = _withAsyncContext(() => Promise.all(promises))),
  await __temp,
  __restore()
);
}
onMounted(() =>
  nextTick(() => {
    window.addEventListener("resize", updateBreakpoint);
  })
);

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateBreakpoint);
});

return (_ctx: any,_cache: any) => {
  const _component_ordinary_classes_manager = _resolveComponent("ordinary-classes-manager")!
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_list_card = _resolveComponent("list-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonAlert), {
      "is-open": alert_open.value,
      header: _unref(alert_information).title,
      message: _unref(alert_information).message,
      buttons: _unref(alert_information).buttons,
      onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (closeModal('success')))
    }, null, 8, ["is-open", "header", "message", "buttons"]),
    _createVNode(_unref(IonGrid), null, {
      default: _withCtx(() => [
        (_unref($route).name == 'ordinary_classes' && _unref(user).type == 'admin')
          ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_ordinary_classes_manager, {
                  onSignal_event: _cache[1] || (_cache[1] = ($event: any) => (setupModalAndOpen()))
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(user).type == 'admin')
          ? (_openBlock(), _createBlock(_unref(IonRow), { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_ionic_element, {
                  element: 
          _unref(getCustomMessage)(
            'export_description',
            _unref(getCurrentElement)('next_session_subscription') + ':',
            'string',
            undefined,
            {
              label: {
                'ion-padding': true,
              },
            }
          )
        
                }, null, 8, ["element"]),
                _createVNode(_component_ionic_element, {
                  element: buttons[0],
                  onExecute_link: exportSubscriptions
                }, null, 8, ["element"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), {
              size: "12",
              "size-md": "6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_list_card, {
                  title: 
            _unref(getCustomMessage)(
              'title',
              _unref(getCurrentElement)(
                _unref($route).name == 'ordinary_classes'
                  ? 'school_years'
                  : 'learning_sessions'
              )
            )
          ,
                  emptiness_message: 
            _unref(getCustomMessage)(
              'emptiness_message',
              _unref(getCurrentElement)(
                _unref($route).name == 'ordinary_classes' ? 'no_years' : 'no_sessions'
              )
            )
          ,
                  cards_list: 
            _unref($route).name == 'ordinary_classes'
              ? school_year_cards
              : learning_sessions
          ,
                  colors: {
            hover: {
              name: 'light',
              alpha: 0.14,
              type: 'var',
            },
            list_borders: {
              name: 'black',
              type: 'var',
              alpha: 0.25,
            },
          },
                  onSignal_event: _cache[2] || (_cache[2] = ($event: any) => (changeSelection()))
                }, null, 8, ["title", "emptiness_message", "cards_list", "colors"])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCol), {
              size: "12",
              "size-md": "6"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_component_list_card, {
                  key: trigger.value,
                  title: 
            _unref(getCustomMessage)(
              'title',
              _unref(getCurrentElement)(
                _unref($route).name == 'ordinary_classes'
                  ? 'ordinary_classes'
                  : 'courses'
              )
            )
          ,
                  emptiness_message: 
            _unref(getCustomMessage)(
              'emptiness_message',
              _unref(getCurrentElement)(
                is_nothing_selected()
                  ? _unref($route).name == 'ordinary_classes'
                    ? 'school_years_selection_message'
                    : 'student_learning_session_selection_message'
                  : _unref($route).name == 'ordinary_classes'
                  ? 'no_classes'
                  : 'no_courses'
              )
            )
          ,
                  columns: 
            _unref($route).name == 'ordinary_classes'
              ? _unref(isSmaller)(breakpoint.value, 'xs')
                ? 4
                : 5
              : undefined
          ,
                  cards_list: 
            _unref($route).name == 'ordinary_classes' ? _unref(ordinary_classes) : courses
          ,
                  colors: 
            _unref($route).name != 'ordinary_classes'
              ? {
                  hover: {
                    name: 'light',
                    alpha: 0.14,
                    type: 'var',
                  },
                  list_borders: {
                    name: 'black',
                    type: 'var',
                    alpha: 0.25,
                  },
                }
              : undefined
          
                }, null, 8, ["title", "emptiness_message", "columns", "cards_list", "colors"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})